<!--消费中心-->
<template>
  <div class="consum-box fs18 cr"  :style="{ backgroundColor: theme.consumColor5 }">
    <div class="all-info-box">
      <div class="head-box">
        <p class="pp1">我的当前积分</p>
        <div class="flex ac">
          <p class="pp2">{{fenshu}}</p>
          <div class="btn1 cr" @click="handleDh">积分兑换</div>
        </div>
      </div>
      <div class="table-box" :style="{ backgroundColor: theme.consumColor1 }">
        <div class="every-info" :style="{ color: theme.consumColor2,borderBottomColor: theme.consumColor6 }">使用明细</div>
        <div class="every-info flex ac jb" v-for="(item,index) in tableData" :key="index" :style="{ borderBottomColor: theme.consumColor6  }">
             <p class="part1-box"  :style="{ color: theme.consumColor2 }">{{item.action_name}}</p>
             <p class="part2-box"  :style="{ color: theme.consumColor3 }">{{item.create_time}}</p>
             <p class="part3-box"  :style="{ color: theme.consumColor4 }">{{item.credits}}</p>
        </div>
      </div>
    </div>
    <el-dialog
      title="积分兑换"
      :visible.sync="dialogVisible2"
      width="30%"
    >
      <div>
        <el-input v-model="code" placeholder="请输入积分兑换码"/>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible2 = false">取 消</el-button>
    <el-button type="primary" @click="submitDh">确 定</el-button>
  </span>
    </el-dialog>

  </div>
</template>
<script>
  import {cdkey, credits, creditsLog} from '../api/user'

  export default {
    name: '',
    computed: {
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    data() {
      return {
        tableData: [], // 表格内容,
        selectObj: {
          start_date: '',
          end_date: '',
          page: 1,
          limit: 99999,
        },
        fenshu: 0,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          },
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        times: [],
        tableLoading: false,
        total: null,
        dialogVisible2: false,
        code: ''
      }
    },
    created() {
      this.getList()
      this.getCredits()
    },
    methods: {
      select() {
        this.selectObj.page = 1
        this.getList(this.selectObj)
      },
      getCredits() {
        credits({}).then(res => {
          this.fenshu = res.data.credits
        })
      },
      handleDh() {
        this.dialogVisible2 = true
      },
      submitDh() {
        cdkey({ code: this.code }).then(res => {
          this.$message.success('您已成功兑换' + res.data.credits + '积分')
          this.code = ''
          this.getCredits()
          this.dialogVisible2 = false
        })
      },
      getList() {
        if (this.times) {
          this.selectObj.start_time = this.times[0]
          this.selectObj.end_time = this.times[1]
        }
        this.tableLoading = true
        creditsLog({...this.selectObj}).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
      },
      // 分页的操作
      handleSizeChange(val) {
        this.selectObj.limit = val
        this.getList(this.selectObj)
      },
      handleCurrentChange(val) {
        this.selectObj.page = val
        this.getList(this.selectObj)
      }
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  p{
    margin: 0;
  }
  .consum-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .consum-box {
    box-sizing: border-box;
    width: 100%;
    padding: 24px;
    height: calc(100vh - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    /*border-radius: 12px;*/

    .all-info-box {
      width: 960px;
      height: 86vh;
      margin: 0 auto;
      .head-box{
        width: 100%;
        height: 158px;
        background: url("../assets/pcImages/8.1_Bg@2x.png")no-repeat;
        background-size: 100%;
        padding: 48px 0 0 40px;
        .pp1{
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          text-align: left;
          margin-bottom: 12px;
        }
        .pp2{
          font-weight: 600;
          font-size: 28px;
          color: #FFFFFF;
          text-align: left;
        }
        .btn1{
          width: 104px;
          height: 32px;
          background: rgba(255,255,255,0.1);
          border-radius: 6px;
          border: 1px solid rgba(255,255,255,0.2);

          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 32px;
          text-align: center;
          margin-left: 24px;
        }
      }
      .table-box::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      .table-box{
        width: 100%;
        height: calc(86vh - 158px);
        overflow-y: scroll;
        overflow-x: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        /*background: #1F2237;*/
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        padding: 0 40px;
        .every-info{
          padding: 16px 0;
          border-bottom: 1px solid;
          font-weight: 500;
          font-size: 16px;
          color: #FAFAFA;
          text-align: left;
           .part1-box{
             width: 500px;
             font-weight: 400;
             font-size: 14px;
             color: #FAFAFAAA;
             text-align: left;
           }
          .part2-box{
            width: 200px;
            font-weight: 400;
            font-size: 14px;
            color: #FAFAFAAA;
            text-align: left;
          }
          .part3-box{
            width: 50px;
            font-weight: 400;
            font-size: 14px;
            color: #01F7F2;
            text-align: left;
          }
        }
      }
    }

    .head-box {

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/consum.vue